//#region imports
import { Injectable } from '@angular/core';
import { ProgressBarService } from './progressbar.service';
import { mobileProgressBarModel, ProgressBarModel } from '../shared/model/progressbar.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import {
  GuaranteeComponentModel, ContexteRequeteModel, CaluclerTarifModel,
  UpdatedTarifRequestModel, ParametreModel
} from '../module/guarantee/model/tarif.model';
import { Pricing, TarificationModel, EvaluationModel, TheftModel, TarifCheckboxStatus } from '../module/guarantee/model/guarantee.model';
import { TranslateService } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';
import { critereParamApplModel, MaxCapitalRequestModel, MaxCapitalResponseModel } from '../shared/model/maxcapital.model';
import { AppConstants } from '../app.constants';
import { Globals } from './globals';
import { SummaryService } from './summary.service';
import { P5xService } from './p5x.service';
import { SectionService } from './section.service';
import { minRequestModel } from '../module/signature/model/signature.model';
//#endregion

@Injectable({
  providedIn: 'root'
})
export class GuaranteeService {
  //#region variables
  batientSum = 0;
  naturePreneur;
  CodeTypeContiguite;
  naturePreneurContenu;
  language;
  postalCode;
  residencePrinciple;
  propertyType;
  contentCovering = false;
  propertyDestinationRenting = false;
  updateEnsuringContentCheck = false;
  maximumCapitalBatiment: string;
  minPremium: string;
  natureAutruiAbandonRecours = '';
  natureAbandonRecoursChecked = false;
  previousEnsuringContentValue;
  initialPricingData: Pricing;
  updatedPricingData: Pricing;
  btnCalculateClickedChk: boolean;
  isPreviousP31Point1: boolean;
  private capitalBatimentEValue: string;
  private backupEnsuringContent: string;
  tarifCheckboxStatus: TarifCheckboxStatus;
  backupFlight: TheftModel;
  backupUpdatedFlight: TheftModel;
  private calculatedPremiumAfterUpdatingCapital: boolean;
  private showNormalTitle = new Subject<boolean>();
  private ensuringContentCalcFirstTime: boolean;
  private premiumTotalAmt = new Subject<string>();
  private showPremiumTot = new Subject<boolean>();
  private flightSubject = new Subject<TheftModel>();
  private ensuringContentSubject = new Subject<string>();
  private tarifRequest;
  private executeTarification;
  private guaranteeFromRecapitulatory: boolean;
  private guaranteeComponent = new BehaviorSubject<GuaranteeComponentModel>(null);
  garantiesBatiment: any;
  garantiesContent: any;
  garantiesContract: any;
  newPricingData: any;
  langvalue = new Subject();
  ensuringContentStr: string;
  capitalContentValueStr: string;
  ensureYourContentChecked: boolean;
  capitalContentValueConstantStr: string;
  capitlContentValueConstant: number;
  premiumAmountStr: string;
  premiumAmount: number;
  capitalContentValue: number;
  //#endregion

  //#region methods
  constructor(
    private progressBarService: ProgressBarService, private httpClient: HttpClient, public translate: TranslateService,
    private decimalPipe: DecimalPipe, private p5xService: P5xService, private global: Globals) { }

  setGuaranteeCurrentPage(firstPage: boolean, SecondPage: boolean, thirdPage: boolean, fourthPage: boolean, fifthPage: boolean) {
    const guaranteeCurrentPage: GuaranteeComponentModel = {
      GuaranteeQuestion1: firstPage, GuaranteeQuestion2: SecondPage, GuaranteeQuestion3: thirdPage,
      GuaranteeQuestion4: fourthPage, GuaranteeQuestion5: fifthPage
    };
    this.setGuaranteeComponent(guaranteeCurrentPage);
  }

  setGuaranteeBatiment(value: []) {
    this.garantiesBatiment = value;
  }

  getGuaranteeBatiment(): [] {
    return this.garantiesBatiment;
  }

  setGuaranteeContent(value: []) {
    this.garantiesContent = value;
  }

  getGuaranteeContent(): [] {
    return this.garantiesContent;
  }

  setGuaranteeContract(value: []) {
    this.garantiesContract = value;
  }

  getGuaranteeContract(): [] {
    return this.garantiesContract;
  }

  setPreviousEnsuringContentValue(value: string) {
    this.previousEnsuringContentValue = value;
  }

  getPreviousEnsuringContentValue(): string {
    return this.previousEnsuringContentValue;
  }

  setInitialPricingData(value: Pricing) {
    this.initialPricingData = value;
    if(value == null){
    this.global.isTheftZero = false;}
  }

  getInitialPricingData(): Pricing {
    return this.initialPricingData;
  }

  setUpdatedPricingData(value: Pricing) {
    this.updatedPricingData = value;
  }

  getUpdatedPricingData(): Pricing {
    return this.updatedPricingData;
  }

  setTarifCheckboxStatus(value: TarifCheckboxStatus) {
    this.tarifCheckboxStatus = value;
  }

  getTarifCheckboxStatus(): TarifCheckboxStatus {
    return this.tarifCheckboxStatus;
  }

  setBtnCalculateClickedChk(value: boolean) {
    this.btnCalculateClickedChk = value;
  }

  getBtnCalculateClickedChk(): boolean {
    return this.btnCalculateClickedChk;
  }

  setCalculatedPremiumAfterUpdatingCapital(value: boolean) {
    this.calculatedPremiumAfterUpdatingCapital = value;
  }

  getCalculatedPremiumAfterUpdatingCapital(): boolean {
    return this.calculatedPremiumAfterUpdatingCapital;
  }

  setIsPreviousP31Point1(value: boolean) {
    this.isPreviousP31Point1 = value;
  }

  getIsPreviousP31Point1(): boolean {
    return this.isPreviousP31Point1;
  }

  getTarificationEvaluationApi(initialJSONResponse) {
    const useMock = AppConstants.UseMock;
    if (useMock) {
      return this.httpClient.get<any>(AppConstants.MockURLS.GetEvaluationTarification);
    } else {
      const url = environment.apiURL + AppConstants.APIURLS.GetEvaluationTarification;
      return this.httpClient.post<any>(url, initialJSONResponse);
    }
  }

  getUpdatedTarificationEvaluationApi(request) {
    const useMock = AppConstants.UseMock;
    if (useMock) {
      return this.httpClient.get<any>(AppConstants.MockURLS.GetUpdatedEvaluationTarification);
    } else {
      const url = environment.apiURL + AppConstants.APIURLS.GetUpdatedEvaluationTarification;
      return this.httpClient.post<any>(url, request);
    }
  }

  getMaximumCapitalBatimentFromAPI() {
    const useMock = AppConstants.UseMock;
    if (useMock) {
      return this.httpClient.get<MaxCapitalResponseModel>(AppConstants.MockURLS.GetMaximumCapital);
    } else {
      const critereParamApplRequest: critereParamApplModel = {
        CodeAppl: 'EG', CodeParam: 'MaxCapitalWeb', DateTime: new Date().toISOString()
      };
      const maxCapitalRequest: MaxCapitalRequestModel = {
        critereParamAppl: critereParamApplRequest
      };
      const url = environment.apiURL + AppConstants.APIURLS.GetMaximumCapital;
      return this.httpClient.post<MaxCapitalResponseModel>(url, maxCapitalRequest);
    }
  }


  getMinPremiumFromAPI() {    
      const minRequest: minRequestModel = {
        MinPremium: 'getminpremium'
      };
      const url = environment.apiURL + AppConstants.APIURLS.GetMinimumPremium;
      return this.httpClient.post<string>(url, minRequest);
  }

  setMaximumCapitalBatiment(value: string) {
    this.maximumCapitalBatiment = value;
  }

  getMaximumCapitalBatiment(): string {
    return this.maximumCapitalBatiment;
  }

  setMinimumPremium(value: string) {
    this.minPremium = value;
  }

  getMinimumPremium(): string {
    return this.minPremium;
  }

  setNaturePreneur(value: string) {
    this.naturePreneur = value;
  }

  getNaturePreneur(): string {
    return this.naturePreneur;
  }

  setNaturePreneurContenu(value: string) {
    this.naturePreneurContenu = value;
  }

  getNaturePreneurContenu(): string {
    return this.naturePreneurContenu;
  }

  setNatureAutruiAbandonRecours(value: string) {
    this.natureAutruiAbandonRecours = value;
  }

  getNatureAutruiAbandonRecours(): string {
    return this.natureAutruiAbandonRecours;
  }

  setNatureAbandonRecoursCheck(value: boolean) {
    this.natureAbandonRecoursChecked = value;
  }

  getNatureAbandonRecoursCheck(): boolean {
    return this.natureAbandonRecoursChecked;
  }



  setpropertyType(value: string) {
    this.propertyType = value;
  }

  getpropertyType(): string {
    return this.propertyType;
  }

  setCodeTypeContiguite(value: string) {
    this.CodeTypeContiguite = value;
  }

  getCodeTypeContiguite(): string {
    return this.CodeTypeContiguite;
  }

  setLanguage(value: string) {
    this.language = value;
    this.langvalue.next(value);
  }

  getDataFR(val: any): any {
    if (val === 'FR'){
      return this.httpClient.get('../../assets/P0FR.txt', {responseType: 'text'});
    } else{
      return this.httpClient.get('../../assets/P0NL.txt', {responseType: 'text'});
    }
  }
  getDataThanks(val: any): any {
    if (val === 'FR'){
      return this.httpClient.get('../../assets/P99FR.txt', {responseType: 'text'});
    } else{
      return this.httpClient.get('../../assets/P99NL.txt', {responseType: 'text'});
    }
  }
  getDataRefuse(val: any): any {
    if (val === 'FR'){
      return this.httpClient.get('../../assets/P100FR.txt', {responseType: 'text'});
    } else{
      return this.httpClient.get('../../assets/P100NL.txt', {responseType: 'text'});
    }
  }
  getLanguage(): string {
    return this.language;
  }

  setPostalCode(value: string) {
    this.postalCode = value;
  }

  getPostalCode(): string {
    return this.postalCode;
  }

  setResidencePrinciple(value: string) {
    this.residencePrinciple = value;
  }

  getResidencePrinciple(): string {
    return this.residencePrinciple;
  }

  setPropertyDestinationRenting(value: boolean) {
    this.propertyDestinationRenting = value;
  }

  getPropertyDestinationRenting(): boolean {
    return this.propertyDestinationRenting && this.p5xService.getIsOwner();
  }

  setContentCovering(value: boolean) {
    this.contentCovering = value;
  }

  getContentCovering(): boolean {
    return this.contentCovering;
  }

  setBackupEnsuringContent(value: string) {
    this.backupEnsuringContent = value;
  }

  getBackupEnsuringContent(): string {
    return this.backupEnsuringContent;
  }

  setBackupFlight(value: TheftModel) {
    this.backupFlight = value;
  }

  getBackupFlight(): TheftModel {
    return this.backupFlight;
  }

  setBackupUpdatedFlight(value: TheftModel) {
    this.backupUpdatedFlight = value;
  }

  getBackupUpdatedFlight(): TheftModel {
    return this.backupUpdatedFlight;
  }

  setGuaranteeFromRecapitulatory(value: boolean) {
    this.guaranteeFromRecapitulatory = value;
  }

  getGuaranteeFromRecapitulatory() {
    return this.guaranteeFromRecapitulatory;
  }

  setTarifRequest(value: any) {
    this.tarifRequest = value;
  }

  getTarifRequest() {
    return this.tarifRequest;
  }

  setGuaranteeComponent(value: GuaranteeComponentModel) {
    this.guaranteeComponent.next(value);
  }

  getGuaranteeComponent(): Observable<GuaranteeComponentModel> {
    return this.guaranteeComponent.asObservable();
  }

  setEnsuringContentCalcFirstTime(value: boolean) {
    this.ensuringContentCalcFirstTime = value;
  }

  getensuringContentCalcFirstTime(): boolean {
    return this.ensuringContentCalcFirstTime;
  }

  setshowNormalTitle(value) {
    this.showNormalTitle.next(value);
  }

  getshowNormalTitle(): Observable<boolean> {
    return this.showNormalTitle.asObservable();
  }

  setExecuteTarification(value: boolean) {
    this.executeTarification = value;
  }

  getExecuteTarification() {
    return this.executeTarification;
  }

  setPremiumTotalAmount(value) {
    this.premiumTotalAmt.next(value);
    this.global.totalPremium = value;
  }

  getPremiumTotalAmount(): Observable<string> {
    return this.premiumTotalAmt.asObservable();
  }

  setPremiumTotalShow(value) {
    this.showPremiumTot.next(value);
  }

  getPremiumTotalShow(): Observable<boolean> {
    return this.showPremiumTot.asObservable();
  }


  setCapitalBatimentvalue(value) {
    this.capitalBatimentEValue = value;
  }

  getCapitalBatimentvalue(): string {
    return this.capitalBatimentEValue;
  }

  convertToString(value: number): string {
    return this.decimalPipe.transform(value, '0.2-2').replace(',', '').replace('.', ',');
  }

  setTarificationValues(tarifData) {
    let batientSum = 0;
    let ensuringContent = 0;
    let legalProtection = 0;
    let flight = 0;
    let deductibleReimbursement = 0;
    let indirectLosses = 0;
    let discontinuanceOfAppeal = 0;
    let premiumVATFireBuildingNet = 0;
    let premiumVATFireBuildingTax = 0;
    let premiumVATFireBuildingAcquisition = 0;
    let premiumVATFireBuildingAdministration = 0;
    let premiumVATFireContentNet = 0;
    let premiumVATFireContentTax = 0;
    let premiumVATFireContentAcquisition = 0;
    let premiumVATFireContentAdministration = 0;
    let premiumAmountVATLegalProtectionNet = 0;
    let premiumAmountVATLegalProtectionTax = 0;
    let premiumAmountVATLegalProtectionAcquisition = 0;
    let premiumAmountVATLegalProtectionAdministration = 0;
    let premiumAmountVATTheftNet = 0;
    let premiumAmountVATTheftTax = 0;
    let premiumAmountVATTheftAcquisition = 0;
    let premiumAmountVATTheftAdministration = 0;
    let premiumAmountVATDeductibleRefundNet = 0;
    let premiumAmountVATDeductibleRefundTax = 0;
    let premiumAmountVATDeductibleRefundAcquisition = 0;
    let premiumAmountVATDeductibleRefundAdministration = 0;
    let premiumAmountVATIndirectLossesNet = 0;
    let premiumAmountVATIndirectLossesTax = 0;
    let premiumAmountVATIndirectLossesAcquisition = 0;
    let premiumAmountVATIndirectLossesAdministration = 0;
    let premiumAmountVATWaiverOfRecourseNet = 0;
    let premiumAmountVATWaiverOfRecourseTax = 0;
    let premiumAmountVATWaiverOfRecourseAcquisition = 0;
    let premiumAmountVATWaiverOfRecourseAdministration = 0;
    const capitalContentValue = +((tarifData.Evaluation.CapitalContenuEvalue).replace(',', '.'));
    const capitalBatimentValueStr = tarifData.Evaluation.CapitalBatimentEvalue;
    const capitalBatimentValue = +((tarifData.Evaluation.CapitalBatimentEvalue).replace(',', '.'));
    this.setCapitalBatimentvalue(capitalBatimentValue);
    this.global.abexValueGlobal = tarifData.Tarificaiton.ValeurIndex;
    if (tarifData.Tarificaiton.GarantiesBatiment) {
      this.setGuaranteeBatiment(tarifData.Tarificaiton.GarantiesBatiment.GarantieTarifee);
      sessionStorage.setItem('garantiesBatiment', JSON.stringify(tarifData.Tarificaiton.GarantiesBatiment.GarantieTarifee));
      const garantiesBatiment = tarifData.Tarificaiton.GarantiesBatiment.GarantieTarifee;
      for (const batiment of garantiesBatiment) {
        if (batiment.RegrDivision !== '091-ABDREC') {
          batientSum = batientSum + (+batiment.PrimeBrute);
          premiumVATFireBuildingNet = premiumVATFireBuildingNet + (+batiment.PrimeNette);
          premiumVATFireBuildingTax = premiumVATFireBuildingTax + (+batiment.Taxes);
          premiumVATFireBuildingAcquisition = premiumVATFireBuildingAcquisition + (+batiment.FraisAcquisition);
          premiumVATFireBuildingAdministration = premiumVATFireBuildingAdministration + (+batiment.FraisAdministration);
        } else if (batiment.RegrDivision === '091-ABDREC') {
          discontinuanceOfAppeal = discontinuanceOfAppeal + (+batiment.PrimeBrute);
          premiumAmountVATWaiverOfRecourseNet = premiumAmountVATWaiverOfRecourseNet + (+batiment.PrimeNette);
          premiumAmountVATWaiverOfRecourseTax = premiumAmountVATWaiverOfRecourseTax + (+batiment.Taxes);
          premiumAmountVATWaiverOfRecourseAcquisition = premiumAmountVATWaiverOfRecourseAcquisition + (+batiment.FraisAcquisition);
          premiumAmountVATWaiverOfRecourseAdministration = premiumAmountVATWaiverOfRecourseAdministration + (+batiment.FraisAdministration);
        }
      }
    }

    if (tarifData.Tarificaiton.GarantiesContenu) {
      this.setGuaranteeContent(tarifData.Tarificaiton.GarantiesContenu.GarantieTarifee);
      sessionStorage.setItem('garantiesContent', JSON.stringify(tarifData.Tarificaiton.GarantiesContenu.GarantieTarifee));
      const guarantisContent = tarifData.Tarificaiton.GarantiesContenu.GarantieTarifee;
      for (const content of guarantisContent) {
        if (content.RegrDivision !== '091-VOL' && content.RegrDivision !== '091-VAN' ) {
          ensuringContent = ensuringContent + (+content.PrimeBrute);
          premiumVATFireContentNet = premiumVATFireContentNet + (+content.PrimeNette);
          premiumVATFireContentTax = premiumVATFireContentTax + (+content.Taxes);
          premiumVATFireContentAcquisition = premiumVATFireContentAcquisition + (+content.FraisAcquisition);
          premiumVATFireContentAdministration = premiumVATFireContentAdministration + (+content.FraisAdministration);
        } else if (content.RegrDivision === '091-VOL') {
          flight = flight + (+content.PrimeBrute);
          premiumAmountVATTheftNet = premiumAmountVATTheftNet + (+content.PrimeNette);
          premiumAmountVATTheftTax = premiumAmountVATTheftTax + (+content.Taxes);
          premiumAmountVATTheftAcquisition = premiumAmountVATTheftAcquisition + (+content.FraisAcquisition);
          premiumAmountVATTheftAdministration = premiumAmountVATTheftAdministration + (+content.FraisAdministration);
        }
      }
    }

    if (tarifData.Tarificaiton.GarantiesContrat) {
      this.setGuaranteeContract(tarifData.Tarificaiton.GarantiesContrat.GarantieTarifee);
      sessionStorage.setItem('garantiesContract', JSON.stringify(tarifData.Tarificaiton.GarantiesContrat.GarantieTarifee));
      const guarantisContract = tarifData.Tarificaiton.GarantiesContrat.GarantieTarifee;
      for (const contract of guarantisContract) {
        if (contract.RegrDivision === '091-PJ') {
          legalProtection = legalProtection + (+contract.PrimeBrute);
          premiumAmountVATLegalProtectionNet = premiumAmountVATLegalProtectionNet + (+contract.PrimeNette);
          premiumAmountVATLegalProtectionTax = premiumAmountVATLegalProtectionTax + (+contract.Taxes);
          premiumAmountVATLegalProtectionAcquisition = premiumAmountVATLegalProtectionAcquisition + (+contract.FraisAcquisition);
          premiumAmountVATLegalProtectionAdministration = premiumAmountVATLegalProtectionAdministration + (+contract.FraisAdministration);
        }
        if (contract.RegrDivision === '091-RMBFRA') {
          deductibleReimbursement = deductibleReimbursement + (+contract.PrimeBrute);
          premiumAmountVATDeductibleRefundNet = premiumAmountVATDeductibleRefundNet + (+contract.PrimeNette);
          premiumAmountVATDeductibleRefundTax = premiumAmountVATDeductibleRefundTax + (+contract.Taxes);
          premiumAmountVATDeductibleRefundAcquisition = premiumAmountVATDeductibleRefundAcquisition + (+contract.FraisAcquisition);
          premiumAmountVATDeductibleRefundAdministration = premiumAmountVATDeductibleRefundAdministration + (+contract.FraisAdministration);
        }
        if (contract.RegrDivision === '091-P-IND') {
          indirectLosses = indirectLosses + (+contract.PrimeBrute);
          premiumAmountVATIndirectLossesNet = premiumAmountVATIndirectLossesNet + (+contract.PrimeNette);
          premiumAmountVATIndirectLossesTax = premiumAmountVATIndirectLossesTax + (+contract.Taxes);
          premiumAmountVATIndirectLossesAcquisition = premiumAmountVATIndirectLossesAcquisition + (+contract.FraisAcquisition);
          premiumAmountVATIndirectLossesAdministration = premiumAmountVATIndirectLossesAdministration + (+contract.FraisAdministration);
        }
      }
    }

    const batientSumStr = this.decimalPipe.transform(batientSum, '0.2-2').replace(',', '').replace('.', ',');
    const ensuringContentStr = this.decimalPipe.transform(ensuringContent, '0.2-2').replace(',', '').replace('.', ',');
    const capitalContentValueStr = this.decimalPipe.transform(capitalContentValue, '0.2-2').replace(',', '').replace('.', ',');
    const legalProtectionStr = this.decimalPipe.transform(legalProtection, '0.2-2').replace(',', '').replace('.', ',');
    const flightStr = this.decimalPipe.transform(flight, '0.2-2').replace(',', '').replace('.', ',');
    const deductibleReimbursementStr = this.decimalPipe.transform(deductibleReimbursement, '0.2-2').replace(',', '').replace('.', ',');
    const indirectLossesStr = this.decimalPipe.transform(indirectLosses, '0.2-2').replace(',', '').replace('.', ',');
    const discontinuanceOfAppealStr = this.decimalPipe.transform(discontinuanceOfAppeal, '0.2-2').replace(',', '').replace('.', ',');

    const tarificationDetails: TarificationModel = {
      Premium_All_Tax_Inclusive: this.translate.instant('Premium_All_Tax_Inclusive_Label'),
      Premium_Frequency_Payment: this.translate.instant('Premium_Frequency_Payment'),
      CapitalContenuEvalue: capitalContentValueStr,
      Premium_VAT_Fire_Building: batientSumStr,
      Premium_VAT_Fire_Building_Net: this.convertToString(premiumVATFireBuildingNet),
      Premium_VAT_Fire_Building_Tax: this.convertToString(premiumVATFireBuildingTax),
      Premium_VAT_Fire_Building_Acquisition: this.convertToString(premiumVATFireBuildingAcquisition),
      Premium_VAT_Fire_Building_Administration: this.convertToString(premiumVATFireBuildingAdministration),
      Premium_VAT_Fire_Content: ensuringContentStr,
      Premium_VAT_Fire_Content_Net: this.convertToString(premiumVATFireContentNet),
      Premium_VAT_Fire_Content_Tax: this.convertToString(premiumVATFireContentTax),
      Premium_VAT_Fire_Content_Acquisition: this.convertToString(premiumVATFireContentAcquisition),
      Premium_VAT_Fire_Content_Administration: this.convertToString(premiumVATFireContentAdministration),
      Premium_VAT_Fire_Content_Checked: !this.getPropertyDestinationRenting(),
      Premium_Amount_VAT_Legal_Protection: legalProtectionStr,
      Premium_Amount_VAT_Legal_Protection_Net: this.convertToString(premiumAmountVATLegalProtectionNet),
      Premium_Amount_VAT_Legal_Protection_Tax: this.convertToString(premiumAmountVATLegalProtectionTax),
      Premium_Amount_VAT_Legal_Protection_Acquisition: this.convertToString(premiumAmountVATLegalProtectionAcquisition),
      Premium_Amount_VAT_Legal_Protection_Administration: this.convertToString(premiumAmountVATLegalProtectionAdministration),
      Premium_Amount_VAT_Legal_Protection_Checked: false,
      Premium_Amount_VAT_Theft: flightStr,
      Premium_Amount_VAT_Theft_Net: this.convertToString(premiumAmountVATTheftNet),
      Premium_Amount_VAT_Theft_Tax: this.convertToString(premiumAmountVATTheftTax),
      Premium_Amount_VAT_Theft_Acquisition: this.convertToString(premiumAmountVATTheftAcquisition),
      Premium_Amount_VAT_Theft_Administration: this.convertToString(premiumAmountVATTheftAdministration),
      Premium_Amount_VAT_Theft_Checked: false,
      Premium_Amount_VAT_Theft_WithAlarm_Checked: false,
      Premium_Amount_VAT_Deductible_Refund: deductibleReimbursementStr,
      Premium_Amount_VAT_Deductible_Refund_Net: this.convertToString(premiumAmountVATDeductibleRefundNet),
      Premium_Amount_VAT_Deductible_Refund_Tax: this.convertToString(premiumAmountVATDeductibleRefundTax),
      Premium_Amount_VAT_Deductible_Refund_Acquisition: this.convertToString(premiumAmountVATDeductibleRefundAcquisition),
      Premium_Amount_VAT_Deductible_Refund_Administration: this.convertToString(premiumAmountVATDeductibleRefundAdministration),
      Premium_Amount_VAT_Deductible_Refund_Checked: false,
      Premium_Amount_VAT_Indirect_Losses: indirectLossesStr,
      Premium_Amount_VAT_Indirect_Losses_Net: this.convertToString(premiumAmountVATIndirectLossesNet),
      Premium_Amount_VAT_Indirect_Losses_Tax: this.convertToString(premiumAmountVATIndirectLossesTax),
      Premium_Amount_VAT_Indirect_Losses_Acquisition: this.convertToString(premiumAmountVATIndirectLossesAcquisition),
      Premium_Amount_VAT_Indirect_Losses_Administration: this.convertToString(premiumAmountVATIndirectLossesAdministration),
      Premium_Amount_VAT_Indirect_Losses_Checked: false,
      Premium_Amount_VAT_Waiver_Of_Recourse: discontinuanceOfAppealStr,
      Premium_Amount_VAT_Waiver_Of_Recourse_Net: this.convertToString(premiumAmountVATWaiverOfRecourseNet),
      Premium_Amount_VAT_Waiver_Of_Recourse_Tax: this.convertToString(premiumAmountVATWaiverOfRecourseTax),
      Premium_Amount_VAT_Waiver_Of_Recourse_Acquisition: this.convertToString(premiumAmountVATWaiverOfRecourseAcquisition),
      Premium_Amount_VAT_Waiver_Of_Recourse_Administration: this.convertToString(premiumAmountVATWaiverOfRecourseAdministration),
      Premium_Amount_VAT_Waiver_Of_Recourse_Checked: false,
      Property_Destination_Renting: this.getPropertyDestinationRenting(),
      Premium_Total_Amount: batientSumStr,
      ValeurIndex: tarifData.Tarificaiton.ValeurIndex,
      TypeIndex: tarifData.Tarificaiton.TypeIndex
    };

    const evaluationDetails: EvaluationModel = {
      CapitalBatimentEvalue: capitalBatimentValueStr,
      CapitalContenuEvalue: capitalContentValueStr
    };

    const pricingDetails: Pricing = {
      Tarification: tarificationDetails,
      Evaluation: evaluationDetails
    };

    // console.log(pricingDetails);

    const theftObj: TheftModel = {
      Premium_Amount_VAT_Theft: flightStr,
      Premium_Amount_VAT_Theft_Net: this.convertToString(premiumAmountVATTheftNet),
      Premium_Amount_VAT_Theft_Tax: this.convertToString(premiumAmountVATTheftTax),
      Premium_Amount_VAT_Theft_Acquisition: this.convertToString(premiumAmountVATTheftAcquisition),
      Premium_Amount_VAT_Theft_Administration: this.convertToString(premiumAmountVATTheftAdministration)
    };
    this.setFlightSubject(theftObj);
    this.setBackupFlight(theftObj);
    if (this.getTarifCheckboxStatus()){
      //do nothing if the check box status is already set for retreival
    }
    else{
      const tarifCheckboxStatus: TarifCheckboxStatus = {
        Premium_VAT_Fire_Content_Checked: true,
        Premium_Amount_VAT_Legal_Protection_Checked: false,
        Premium_Amount_VAT_Theft_Checked: false,
        Premium_Amount_VAT_Theft_WithAlarm_Checked: false,
        Premium_Amount_VAT_Deductible_Refund_Checked: false,
        Premium_Amount_VAT_Indirect_Losses_Checked: false,
        Premium_Amount_VAT_Waiver_Of_Recourse_Checked: false
      };
      this.setTarifCheckboxStatus(tarifCheckboxStatus);
  }

    this.setInitialPricingData(pricingDetails);
    this.setPremiumTotalAmount(batientSumStr);
    this.setPreviousEnsuringContentValue(ensuringContentStr);
    this.setEnsuringContentCalcFirstTime(false); //(true);
  }

  updateTarifRequest(alameAgreeIncert: string, capitalContenu: string) {
    let residencePrincipale = this.getResidencePrinciple();
    if (residencePrincipale !== 'true') {
      residencePrincipale = 'false';
    }

    if (!this.p5xService.getIsOwner()) {
      residencePrincipale = 'true';
    }

    const parametreData: ParametreModel = {
      _toDelete: 'false',
      AlameAgreeIncert: alameAgreeIncert,
      Branche: '091',
      CodePostal: this.getPostalCode(),
      DateTarif: new Date().toISOString(),
      CapitalBatiment: this.getInitialPricingData().Evaluation.CapitalBatimentEvalue.replace(',', '.'),
      CapitalContenu: capitalContenu.toString().replace(',', '.'),
      EtatBatiment: 'NORMAL',
      Langue: this.getLanguage(),
      NatureAutruiAbandonRecours: this.getNatureAutruiAbandonRecours(),
      NaturePreneur: this.getNaturePreneur(),
      NaturePreneurContenu: this.getNaturePreneurContenu(),
      Periodicite: 'ANNUAL',
      TarifBuilding: 'false',
      TypeBatiment: this.getpropertyType(),
      TypeConstruction: 'TRADI',
      TypeContenu: 'GENERAL',
      TypeSituation: 'PROJET',
      UsageBatiment: 'HABITA',
      CodeTypeContiguite: this.getCodeTypeContiguite(),
      ResidencePrincipale: residencePrincipale
    };
    const caluclerTarifData: CaluclerTarifModel = {
      parametre: parametreData
    };
    const contexteRequeteData: ContexteRequeteModel = {
      LangueClient: this.getLanguage(),
      Utilisateur: environment.esbuser
      //'BizTalkDevUserESB', BizTalkTstUserESB, BizTalkAccUserESB, BizTalkPrdUserESB
    };
    const updatedTarifRequest: UpdatedTarifRequestModel = {
      PropertyType: this.getpropertyType(),
      CapitalUpdate: 'true',
      CaluclerTarif: caluclerTarifData,
      contexteRequete: contexteRequeteData,
      '_xmlns:ns0': 'http://AFV.ESB.Biz.CALASS.JSON',
      __prefix: 'ns0',
    };
    // console.log(updatedTarifRequest);
    const updateTarifReqData = JSON.stringify(updatedTarifRequest);
    const request = { UpdateTarifRequest: updateTarifReqData };
    return request;
  }

  updateTarifEnsuringContentCalculation(capitalContentEValue, tarifData) {
    let currentEnsuringContent = 0;
    let legalProtection = 0;
    let flight = 0;
    let deductibleReimbursement = 0;
    let indirectLosses = 0;
    let premiumVATFireContentNet = 0;
    let premiumVATFireContentTax = 0;
    let premiumVATFireContentAcquisition = 0;
    let premiumVATFireContentAdministration = 0;
    let premiumAmountVATLegalProtectionNet = 0;
    let premiumAmountVATLegalProtectionTax = 0;
    let premiumAmountVATLegalProtectionAcquisition = 0;
    let premiumAmountVATLegalProtectionAdministration = 0;
    let premiumAmountVATTheftNet = 0;
    let premiumAmountVATTheftTax = 0;
    let premiumAmountVATTheftAcquisition = 0;
    let premiumAmountVATTheftAdministration = 0;
    let premiumAmountVATDeductibleRefundNet = 0;
    let premiumAmountVATDeductibleRefundTax = 0;
    let premiumAmountVATDeductibleRefundAcquisition = 0;
    let premiumAmountVATDeductibleRefundAdministration = 0;
    let premiumAmountVATIndirectLossesNet = 0;
    let premiumAmountVATIndirectLossesTax = 0;
    let premiumAmountVATIndirectLossesAcquisition = 0;
    let premiumAmountVATIndirectLossesAdministration = 0;
    this.global.abexValueGlobal = tarifData.Tarificaiton.ValeurIndex;
    if (tarifData.Tarificaiton.GarantiesContenu) {
      this.setGuaranteeContent(tarifData.Tarificaiton.GarantiesContenu.GarantieTarifee);
      sessionStorage.setItem('garantiesContent', JSON.stringify(tarifData.Tarificaiton.GarantiesContenu.GarantieTarifee));
      const guarantisContent = tarifData.Tarificaiton.GarantiesContenu.GarantieTarifee;
      for (const content of guarantisContent) {
        if (content.RegrDivision !== '091-VOL' && content.RegrDivision !== '091-VAN') {
          currentEnsuringContent = currentEnsuringContent + (+content.PrimeBrute);
          premiumVATFireContentNet = premiumVATFireContentNet + (+content.PrimeNette);
          premiumVATFireContentTax = premiumVATFireContentTax + (+content.Taxes);
          premiumVATFireContentAcquisition = premiumVATFireContentAcquisition + (+content.FraisAcquisition);
          premiumVATFireContentAdministration = premiumVATFireContentAdministration + (+content.FraisAdministration);
        } else if (content.RegrDivision === '091-VOL') {
          flight = flight + (+content.PrimeBrute);
          premiumAmountVATTheftNet = premiumAmountVATTheftNet + (+content.PrimeNette);
          premiumAmountVATTheftTax = premiumAmountVATTheftTax + (+content.Taxes);
          premiumAmountVATTheftAcquisition = premiumAmountVATTheftAcquisition + (+content.FraisAcquisition);
          premiumAmountVATTheftAdministration = premiumAmountVATTheftAdministration + (+content.FraisAdministration);
        }
      }
    }

    if (tarifData.Tarificaiton.GarantiesContrat) {
      this.setGuaranteeContract(tarifData.Tarificaiton.GarantiesContrat.GarantieTarifee);
      sessionStorage.setItem('garantiesContract', JSON.stringify(tarifData.Tarificaiton.GarantiesContrat.GarantieTarifee));
      const guarantisContract = tarifData.Tarificaiton.GarantiesContrat.GarantieTarifee;
      for (const contract of guarantisContract) {
        if (contract.RegrDivision === '091-PJ') {
          legalProtection = legalProtection + (+contract.PrimeBrute);
          premiumAmountVATLegalProtectionNet = premiumAmountVATLegalProtectionNet + (+contract.PrimeNette);
          premiumAmountVATLegalProtectionTax = premiumAmountVATLegalProtectionTax + (+contract.Taxes);
          premiumAmountVATLegalProtectionAcquisition = premiumAmountVATLegalProtectionAcquisition + (+contract.FraisAcquisition);
          premiumAmountVATLegalProtectionAdministration = premiumAmountVATLegalProtectionAdministration + (+contract.FraisAdministration);
        }
        if (contract.RegrDivision === '091-RMBFRA') {
          deductibleReimbursement = deductibleReimbursement + (+contract.PrimeBrute);
          premiumAmountVATDeductibleRefundNet = premiumAmountVATDeductibleRefundNet + (+contract.PrimeNette);
          premiumAmountVATDeductibleRefundTax = premiumAmountVATDeductibleRefundTax + (+contract.Taxes);
          premiumAmountVATDeductibleRefundAcquisition = premiumAmountVATDeductibleRefundAcquisition + (+contract.FraisAcquisition);
          premiumAmountVATDeductibleRefundAdministration = premiumAmountVATDeductibleRefundAdministration + (+contract.FraisAdministration);
        }
        if (contract.RegrDivision === '091-P-IND') {
          indirectLosses = indirectLosses + (+contract.PrimeBrute);
          premiumAmountVATIndirectLossesNet = premiumAmountVATIndirectLossesNet + (+contract.PrimeNette);
          premiumAmountVATIndirectLossesTax = premiumAmountVATIndirectLossesTax + (+contract.Taxes);
          premiumAmountVATIndirectLossesAcquisition = premiumAmountVATIndirectLossesAcquisition + (+contract.FraisAcquisition);
          premiumAmountVATIndirectLossesAdministration = premiumAmountVATIndirectLossesAdministration + (+contract.FraisAdministration);
        }
      }
    }

    let currentEnsuringContentStr;
    if (currentEnsuringContent === 0) {
      currentEnsuringContentStr = this.getInitialPricingData().Tarification.Premium_VAT_Fire_Content;
      //the below block defined to retain the other fields when calling the update premium without content
      premiumVATFireContentNet = Number(this.getInitialPricingData().Tarification.Premium_VAT_Fire_Content_Net.replace(',','.'));
      premiumVATFireContentTax =  Number(this.getInitialPricingData().Tarification.Premium_VAT_Fire_Content_Tax.replace(',','.'));
      premiumVATFireContentAcquisition =  Number(this.getInitialPricingData().Tarification.Premium_VAT_Fire_Content_Acquisition.replace(',','.'));
      premiumVATFireContentAdministration =  Number(this.getInitialPricingData().Tarification.Premium_VAT_Fire_Content_Administration.replace(',','.'));
    } else {
      currentEnsuringContentStr = this.decimalPipe.transform(currentEnsuringContent, '0.2-2').replace(',', '').replace('.', ',');
    }
    const legalProtectionStr = this.decimalPipe.transform(legalProtection, '0.2-2').replace(',', '').replace('.', ',');
    let flightStr;
    if (currentEnsuringContent === 0) {
      flightStr = this.getInitialPricingData().Tarification.Premium_Amount_VAT_Theft;
      premiumAmountVATTheftNet =  Number(this.getInitialPricingData().Tarification.Premium_Amount_VAT_Theft_Net.replace(',','.'));
      premiumAmountVATTheftTax =  Number(this.getInitialPricingData().Tarification.Premium_Amount_VAT_Theft_Tax.replace(',','.'));
      premiumAmountVATTheftAcquisition =  Number(this.getInitialPricingData().Tarification.Premium_Amount_VAT_Theft_Acquisition.replace(',','.'));
      premiumAmountVATTheftAdministration =  Number(this.getInitialPricingData().Tarification.Premium_Amount_VAT_Theft_Administration.replace(',','.'));
    } else {
      flightStr = this.decimalPipe.transform(flight, '0.2-2').replace(',', '').replace('.', ',');
    }
    const deductibleReimbursementStr = this.decimalPipe.transform(deductibleReimbursement, '0.2-2').replace(',', '').replace('.', ',');
    const indirectLossesStr = this.decimalPipe.transform(indirectLosses, '0.2-2').replace(',', '').replace('.', ',');

    const tarifCheckboxStatus = this.getTarifCheckboxStatus();
    const tarificationDetails: TarificationModel = {
      Premium_All_Tax_Inclusive: this.translate.instant('Premium_All_Tax_Inclusive_Label'),
      Premium_Frequency_Payment: this.translate.instant('Premium_Frequency_Payment'),
      CapitalContenuEvalue: capitalContentEValue,
      Premium_VAT_Fire_Building: this.getInitialPricingData().Tarification.Premium_VAT_Fire_Building,
      Premium_VAT_Fire_Building_Net: this.getInitialPricingData().Tarification.Premium_VAT_Fire_Building_Net,
      Premium_VAT_Fire_Building_Tax: this.getInitialPricingData().Tarification.Premium_VAT_Fire_Building_Tax,
      Premium_VAT_Fire_Building_Acquisition: this.getInitialPricingData().Tarification.Premium_VAT_Fire_Building_Acquisition,
      Premium_VAT_Fire_Building_Administration: this.getInitialPricingData().Tarification.Premium_VAT_Fire_Building_Administration,
      Premium_VAT_Fire_Content: currentEnsuringContentStr,
      Premium_VAT_Fire_Content_Net: this.convertToString(premiumVATFireContentNet),
      Premium_VAT_Fire_Content_Tax: this.convertToString(premiumVATFireContentTax),
      Premium_VAT_Fire_Content_Acquisition: this.convertToString(premiumVATFireContentAcquisition),
      Premium_VAT_Fire_Content_Administration: this.convertToString(premiumVATFireContentAdministration),
      Premium_VAT_Fire_Content_Checked: tarifCheckboxStatus.Premium_VAT_Fire_Content_Checked,
      Premium_Amount_VAT_Legal_Protection: legalProtectionStr,
      Premium_Amount_VAT_Legal_Protection_Net: this.convertToString(premiumAmountVATLegalProtectionNet),
      Premium_Amount_VAT_Legal_Protection_Tax: this.convertToString(premiumAmountVATLegalProtectionTax),
      Premium_Amount_VAT_Legal_Protection_Acquisition: this.convertToString(premiumAmountVATLegalProtectionAcquisition),
      Premium_Amount_VAT_Legal_Protection_Administration: this.convertToString(premiumAmountVATLegalProtectionAdministration),
      Premium_Amount_VAT_Legal_Protection_Checked: tarifCheckboxStatus.Premium_Amount_VAT_Legal_Protection_Checked,
      Premium_Amount_VAT_Theft: flightStr,
      Premium_Amount_VAT_Theft_Net: this.convertToString(premiumAmountVATTheftNet),
      Premium_Amount_VAT_Theft_Tax: this.convertToString(premiumAmountVATTheftTax),
      Premium_Amount_VAT_Theft_Acquisition: this.convertToString(premiumAmountVATTheftAcquisition),
      Premium_Amount_VAT_Theft_Administration: this.convertToString(premiumAmountVATTheftAdministration),
      Premium_Amount_VAT_Theft_Checked: tarifCheckboxStatus.Premium_Amount_VAT_Theft_Checked,
      Premium_Amount_VAT_Theft_WithAlarm_Checked: tarifCheckboxStatus.Premium_Amount_VAT_Theft_WithAlarm_Checked,
      Premium_Amount_VAT_Deductible_Refund: deductibleReimbursementStr,
      Premium_Amount_VAT_Deductible_Refund_Net: this.convertToString(premiumAmountVATDeductibleRefundNet),
      Premium_Amount_VAT_Deductible_Refund_Tax: this.convertToString(premiumAmountVATDeductibleRefundTax),
      Premium_Amount_VAT_Deductible_Refund_Acquisition: this.convertToString(premiumAmountVATDeductibleRefundAcquisition),
      Premium_Amount_VAT_Deductible_Refund_Administration: this.convertToString(premiumAmountVATDeductibleRefundAdministration),
      Premium_Amount_VAT_Deductible_Refund_Checked: tarifCheckboxStatus.Premium_Amount_VAT_Deductible_Refund_Checked,
      Premium_Amount_VAT_Indirect_Losses: indirectLossesStr,
      Premium_Amount_VAT_Indirect_Losses_Net: this.convertToString(premiumAmountVATIndirectLossesNet),
      Premium_Amount_VAT_Indirect_Losses_Tax: this.convertToString(premiumAmountVATIndirectLossesTax),
      Premium_Amount_VAT_Indirect_Losses_Acquisition: this.convertToString(premiumAmountVATIndirectLossesAcquisition),
      Premium_Amount_VAT_Indirect_Losses_Administration: this.convertToString(premiumAmountVATIndirectLossesAdministration),
      Premium_Amount_VAT_Indirect_Losses_Checked: tarifCheckboxStatus.Premium_Amount_VAT_Indirect_Losses_Checked,
      Premium_Amount_VAT_Waiver_Of_Recourse: this.getInitialPricingData().Tarification.Premium_Amount_VAT_Waiver_Of_Recourse,
      Premium_Amount_VAT_Waiver_Of_Recourse_Net: this.getInitialPricingData().Tarification.Premium_Amount_VAT_Waiver_Of_Recourse_Net,
      Premium_Amount_VAT_Waiver_Of_Recourse_Tax: this.getInitialPricingData().Tarification.Premium_Amount_VAT_Waiver_Of_Recourse_Tax,
      Premium_Amount_VAT_Waiver_Of_Recourse_Acquisition:
        this.getInitialPricingData().Tarification.Premium_Amount_VAT_Waiver_Of_Recourse_Acquisition,
      Premium_Amount_VAT_Waiver_Of_Recourse_Administration:
        this.getInitialPricingData().Tarification.Premium_Amount_VAT_Waiver_Of_Recourse_Administration,
      Premium_Amount_VAT_Waiver_Of_Recourse_Checked: tarifCheckboxStatus.Premium_Amount_VAT_Waiver_Of_Recourse_Checked,
      Property_Destination_Renting: this.getPropertyDestinationRenting(),
      Premium_Total_Amount: this.getInitialPricingData().Tarification.Premium_VAT_Fire_Building,
      ValeurIndex: tarifData.Tarificaiton.ValeurIndex,
      TypeIndex: tarifData.Tarificaiton.TypeIndex
    };

    let updatedPremiumAmount = +(this.getInitialPricingData().Tarification.Premium_VAT_Fire_Building.replace(',', '.'));
    if (tarifCheckboxStatus.Premium_VAT_Fire_Content_Checked) {
      updatedPremiumAmount += currentEnsuringContent;
    }
    if (tarifCheckboxStatus.Premium_Amount_VAT_Legal_Protection_Checked) {
      updatedPremiumAmount += legalProtection;
    }
    if (tarifCheckboxStatus.Premium_Amount_VAT_Theft_Checked) {
      updatedPremiumAmount += flight;
    }
    if (tarifCheckboxStatus.Premium_Amount_VAT_Deductible_Refund_Checked) {
      updatedPremiumAmount += deductibleReimbursement;
    }
    if (tarifCheckboxStatus.Premium_Amount_VAT_Indirect_Losses_Checked) {
      updatedPremiumAmount += indirectLosses;
    }
    if (tarifCheckboxStatus.Premium_Amount_VAT_Waiver_Of_Recourse_Checked) {
      const discontinuanceOfAppeal = this.getInitialPricingData().Tarification.Premium_Amount_VAT_Waiver_Of_Recourse;
      updatedPremiumAmount += +(this.decimalPipe.transform(discontinuanceOfAppeal, '0.2-2').replace(',', '').replace('.', ','));
    }
    updatedPremiumAmount = +(this.decimalPipe.transform(updatedPremiumAmount, '0.2-2').replace(',', ''));
    tarificationDetails.Premium_Total_Amount = updatedPremiumAmount.toString().replace('.', ',');
    this.setPremiumTotalAmount(tarificationDetails.Premium_Total_Amount);

    const evaluationDetails: EvaluationModel = {
      CapitalBatimentEvalue: this.getInitialPricingData().Evaluation.CapitalBatimentEvalue,
      CapitalContenuEvalue: this.getInitialPricingData().Evaluation.CapitalContenuEvalue
    };

    const updatedPricingDetails: Pricing = {
      Tarification: tarificationDetails,
      Evaluation: evaluationDetails
    };

    this.setUpdatedPricingData(updatedPricingDetails);
    const theftObj: TheftModel = {
      Premium_Amount_VAT_Theft: flightStr,
      Premium_Amount_VAT_Theft_Net: updatedPricingDetails.Tarification.Premium_Amount_VAT_Theft_Net,
      Premium_Amount_VAT_Theft_Tax: updatedPricingDetails.Tarification.Premium_Amount_VAT_Theft_Tax,
      Premium_Amount_VAT_Theft_Acquisition: updatedPricingDetails.Tarification.Premium_Amount_VAT_Theft_Acquisition,
      Premium_Amount_VAT_Theft_Administration: updatedPricingDetails.Tarification.Premium_Amount_VAT_Theft_Administration
    };
    this.setBackupUpdatedFlight(theftObj);
    //Don't delete - Commented this block as again this theft check is not required defect 1527 
    // if (this.getInitialPricingData().Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked) {
    //   // console.log('Backup Flight:' + flightStr);
    //   const request = this.updateTarifRequest('true', (this.convertToNumber(capitalContentEValue)).toString());
    //   this.getUpdatedTarificationEvaluationApi(request).subscribe((response) => {
    //     updatedPricingDetails.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = true;
    //     tarifCheckboxStatus.Premium_Amount_VAT_Theft_WithAlarm_Checked = true;
    //     this.setTarifCheckboxStatus(tarifCheckboxStatus);
    //     this.setUpdatedPricingData(updatedPricingDetails);
    //     // console.log(response);
    //     this.updateTarifTheftCalculation(response);
    //   });
    // }
    return updatedPricingDetails;
  }

  convertToNumber(value: string): number {
    return +(value.replace(',', '.'));
  }

  updateTarifTheftCalculation(tarifData) {
    let flight = 0;
    let premiumAmountVATTheftNet = 0;
    let premiumAmountVATTheftTax = 0;
    let premiumAmountVATTheftAcquisition = 0;
    let premiumAmountVATTheftAdministration = 0;
    if (tarifData.Tarificaiton.GarantiesContenu) {
      const guarantisContent = tarifData.Tarificaiton.GarantiesContenu.GarantieTarifee;
      sessionStorage.setItem('garantiesContent', JSON.stringify(tarifData.Tarificaiton.GarantiesContenu.GarantieTarifee)); 
      
      for (const content of guarantisContent) {
        if (content.RegrDivision === '091-VOL') {
          flight = flight + (+content.PrimeBrute);
          premiumAmountVATTheftNet = premiumAmountVATTheftNet + (+content.PrimeNette);
          premiumAmountVATTheftTax = premiumAmountVATTheftTax + (+content.Taxes);
          premiumAmountVATTheftAcquisition = premiumAmountVATTheftAcquisition + (+content.FraisAcquisition);
          premiumAmountVATTheftAdministration = premiumAmountVATTheftAdministration + (+content.FraisAdministration);
        }
      }
    }
    const flightStr = this.decimalPipe.transform(flight, '0.2-2').replace(',', '').replace('.', ',');
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft = flightStr;
      this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Net = this.convertToString(premiumAmountVATTheftNet);
      this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Tax = this.convertToString(premiumAmountVATTheftTax);
      this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Acquisition = this.convertToString(premiumAmountVATTheftAcquisition);
      this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Administration =
        this.convertToString(premiumAmountVATTheftAdministration);
    } else {
      this.initialPricingData.Tarification.Premium_Amount_VAT_Theft = flightStr;
      this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Net = this.convertToString(premiumAmountVATTheftNet);
      this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Tax = this.convertToString(premiumAmountVATTheftTax);
      this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Acquisition = this.convertToString(premiumAmountVATTheftAcquisition);
      this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Administration =
        this.convertToString(premiumAmountVATTheftAdministration);
    }
    const theftObj: TheftModel = {
      Premium_Amount_VAT_Theft: flightStr,
      Premium_Amount_VAT_Theft_Net: this.convertToString(premiumAmountVATTheftNet),
      Premium_Amount_VAT_Theft_Tax: this.convertToString(premiumAmountVATTheftTax),
      Premium_Amount_VAT_Theft_Acquisition: this.convertToString(premiumAmountVATTheftAcquisition),
      Premium_Amount_VAT_Theft_Administration: this.convertToString(premiumAmountVATTheftAdministration)
    };
    this.setFlightSubject(theftObj);
    // console.log(theftObj);

    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      if (this.getUpdatedPricingData().Tarification.Premium_Amount_VAT_Theft_Checked) {
        const originalFlightValue = +this.getBackupUpdatedFlight().Premium_Amount_VAT_Theft.replace(',', '.');
        let premiumTotalAmountStr = this.getUpdatedPricingData().Tarification.Premium_Total_Amount;
        let premiumTotalAmount = +(premiumTotalAmountStr.replace(',', '.'));
        premiumTotalAmount = premiumTotalAmount - originalFlightValue +
          (+(this.decimalPipe.transform(flight, '0.2-2').replace(',', '')));
        premiumTotalAmountStr = this.decimalPipe.transform(premiumTotalAmount, '0.2-2').replace(',', '').replace('.', ',');
        this.updatedPricingData.Tarification.Premium_Total_Amount = premiumTotalAmountStr;
        this.setPremiumTotalAmount(premiumTotalAmountStr);
      }
    } else {
      if (this.getInitialPricingData().Tarification.Premium_Amount_VAT_Theft_Checked) {
        const originalFlightValue = +this.getBackupFlight().Premium_Amount_VAT_Theft.replace(',', '.');
        let premiumTotalAmountStr = this.getInitialPricingData().Tarification.Premium_Total_Amount;
        let premiumTotalAmount = +(premiumTotalAmountStr.replace(',', '.'));
        premiumTotalAmount = premiumTotalAmount - originalFlightValue +
          (+(this.decimalPipe.transform(flight, '0.2-2').replace(',', '')));
        premiumTotalAmountStr = this.decimalPipe.transform(premiumTotalAmount, '0.2-2').replace(',', '').replace('.', ',');
        this.initialPricingData.Tarification.Premium_Total_Amount = premiumTotalAmountStr;
        this.setPremiumTotalAmount(premiumTotalAmountStr);
      }
    }
  }

  setEnsuringContentSubject(value) {
    this.ensuringContentSubject.next(value);
  }

  getEnsuringContentSubject(): Observable<string> {
    return this.ensuringContentSubject.asObservable();
  }

  setUpdateEnsuringContentCheck(value: boolean) {
    this.updateEnsuringContentCheck = value;
  }

  getUpdateEnsuringContentCheck() {
    return this.updateEnsuringContentCheck;
  }

  setFlightSubject(value: TheftModel) {
    this.flightSubject.next(value);
  }

  getFlightSubject(): Observable<TheftModel> {
    return this.flightSubject.asObservable();
  }

  setGuaranteeProgressBarDetails() {
    const characteristicsProgressStatus: ProgressBarModel = {
      Disable: false, Number: false, Icon: true
    };
    const detailsProgressStatus: ProgressBarModel = {
      Disable: false, Number: false, Icon: true
    };
    const guaranteeProgressStatus: ProgressBarModel = {
      Disable: false, Number: false, Icon: false
    };
    const summaryProgressStatus: ProgressBarModel = {
      Disable: true, Number: true, Icon: false
    };
    const signatureProgressStatus: ProgressBarModel = {
      Disable: true, Number: true, Icon: false
    };
    this.progressBarService.setCharacteristicsProgressStatus(characteristicsProgressStatus);
    this.progressBarService.setDetailsProgressStatus(detailsProgressStatus);
    this.progressBarService.setGauranteeProgressStatus(guaranteeProgressStatus);
    this.progressBarService.setSummaryProgressStatus(summaryProgressStatus);
    this.progressBarService.setSignatureProgressStatus(signatureProgressStatus);
  }

  setmobileGuaranteeProgressBarDetails() {
    const characteristicsProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const detailsProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const guaranteeProgressStatus: mobileProgressBarModel = {
      Enable: true
    };
    const summaryProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const signatureProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    this.progressBarService.setmobileCharacteristicsProgressStatus(characteristicsProgressStatus);
    this.progressBarService.setmobileDetailsProgressStatus(detailsProgressStatus);
    this.progressBarService.setmobileGauranteeProgressStatus(guaranteeProgressStatus);
    this.progressBarService.setmobileSummaryProgressStatus(summaryProgressStatus);
    this.progressBarService.setmobileSignatureProgressStatus(signatureProgressStatus);
    if (document.getElementById("tab1") !== null && document.getElementById("tab1") !== undefined 
    && document.getElementById("tab2") !== null && document.getElementById("tab2") !== undefined
    && document.getElementById("tab3") !== null && document.getElementById("tab3") !== undefined
    && document.getElementById("tab4") !== null && document.getElementById("tab4") !== undefined
    && document.getElementById("tab5") !== null && document.getElementById("tab5") !== undefined ){
    document.getElementById("tab1").classList.remove("d-none");
    document.getElementById("tab2").classList.remove("d-none");
    document.getElementById("tab3").classList.remove("d-none");
    document.getElementById("tab5").classList.remove("d-none");
    document.getElementById("tab4").querySelector(".panel-heading").classList.remove("d-none");
    }
  }

oncheckedChangeContent(isChecked)
{
  //this.guaranteeService.setGuaranteeProgressBarDetails();
  //if(this.globals.isMobile)
  //{this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
  this.initialPricingData = this.getInitialPricingData();
    this.updatedPricingData = this.getUpdatedPricingData();
    this.tarifCheckboxStatus = this.getTarifCheckboxStatus();
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      this.ensureYourContentChecked = this.updatedPricingData.Tarification.Premium_VAT_Fire_Content_Checked;
      this.capitalContentValueConstantStr = this.initialPricingData.Evaluation.CapitalContenuEvalue;
      this.capitalContentValueStr = this.updatedPricingData.Tarification.CapitalContenuEvalue;
      this.capitlContentValueConstant = +this.capitalContentValueConstantStr.replace(',', '.');
      this.premiumAmountStr = this.updatedPricingData.Tarification.Premium_Total_Amount;
      this.ensuringContentStr = this.updatedPricingData.Tarification.Premium_VAT_Fire_Content;
      this.setPremiumTotalAmount(this.updatedPricingData.Tarification.Premium_Total_Amount);
    } else {
      this.ensureYourContentChecked = this.initialPricingData.Tarification.Premium_VAT_Fire_Content_Checked;
      this.premiumAmountStr = this.initialPricingData.Tarification.Premium_Total_Amount;
      this.setPremiumTotalAmount(this.initialPricingData.Tarification.Premium_Total_Amount);
      this.ensuringContentStr = this.initialPricingData.Tarification.Premium_VAT_Fire_Content;
      this.capitalContentValueStr = this.initialPricingData.Tarification.CapitalContenuEvalue;
      this.capitalContentValueConstantStr = this.initialPricingData.Evaluation.CapitalContenuEvalue;
      this.capitlContentValueConstant = +this.capitalContentValueConstantStr.replace(',', '.');
    }
  if (isChecked) {
    this.setUpdatedPricingData(null);
    this.setContentCovering(true);
    this.p5xService.setTheftChecked(false);
    this.setPremiumTotalAmount(this.initialPricingData.Tarification.Premium_Total_Amount);
    this.ensuringContentStr = this.initialPricingData.Tarification.Premium_VAT_Fire_Content;
    this.capitalContentValueStr = this.capitalContentValueConstantStr;
    this.initialPricingData.Tarification.CapitalContenuEvalue = this.capitalContentValueStr;
    this.initialPricingData.Tarification.Premium_VAT_Fire_Content_Checked = true;
    this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Checked = false;
    this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
    this.premiumAmountStr = this.initialPricingData.Tarification.Premium_VAT_Fire_Building;
    this.premiumAmount = this.convertToNumber(this.premiumAmountStr);
    this.premiumAmount = this.premiumAmount + this.convertToNumber(this.ensuringContentStr);
    this.premiumAmountStr = this.convertToString(this.premiumAmount);
    this.initialPricingData.Tarification.Premium_Total_Amount = this.premiumAmountStr;
    const backupFlight = this.getBackupFlight();
    if (backupFlight !== undefined && backupFlight !== null) {
      const premiumAmountVatTheft = this.getBackupFlight().Premium_Amount_VAT_Theft;
      const premiumAmountVatTheftNet = this.getBackupFlight().Premium_Amount_VAT_Theft_Net;
      const premiumAmountVatTheftTax = this.getBackupFlight().Premium_Amount_VAT_Theft_Tax;
      const premiumAmountVatTheftAcquisition = this.getBackupFlight().Premium_Amount_VAT_Theft_Acquisition;
      const premiumAmountVatTheftAdministration = this.getBackupFlight().Premium_Amount_VAT_Theft_Administration;
      this.initialPricingData.Tarification.Premium_Amount_VAT_Theft = premiumAmountVatTheft;
      this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Net = premiumAmountVatTheftNet;
      this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Tax = premiumAmountVatTheftTax;
      this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Acquisition = premiumAmountVatTheftAcquisition;
      this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Administration = premiumAmountVatTheftAdministration;
    }
    const legalProtectionStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Legal_Protection;
    const legalProtection = this.convertToNumber(legalProtectionStr);
    const deductableReimbursementStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund;
    const deductableReimbursement = this.convertToNumber(deductableReimbursementStr);
    const indirectLossesStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses;
    const indirectLosses = this.convertToNumber(indirectLossesStr);
    if (this.initialPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked) {
      this.premiumAmount = this.premiumAmount + legalProtection;
      this.premiumAmountStr = this.convertToString(this.premiumAmount);
    }
    if (this.initialPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund_Checked) {
      this.premiumAmount = this.premiumAmount + deductableReimbursement;
      this.premiumAmountStr = this.convertToString(this.premiumAmount);
    }
    if (this.initialPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses_Checked) {
      this.premiumAmount = this.premiumAmount + indirectLosses;
      this.premiumAmountStr = this.convertToString(this.premiumAmount);
    }
    this.initialPricingData.Tarification.Premium_Total_Amount = this.premiumAmountStr;
    this.setPremiumTotalAmount(this.premiumAmountStr);
    this.ensureYourContentChecked = true;
    this.setInitialPricingData(this.initialPricingData);
    this.tarifCheckboxStatus.Premium_VAT_Fire_Content_Checked = true;
    this.setTarifCheckboxStatus(this.tarifCheckboxStatus);
  } else {
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      if (this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked) {
        const originalFlightValue = this.getBackupUpdatedFlight().Premium_Amount_VAT_Theft;
        const premiumAmountVatTheftNet = this.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Net;
        const premiumAmountVatTheftTax = this.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Tax;
        const premiumAmountVatTheftAcquisition = this.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Acquisition;
        const premiumAmountVatTheftAdministration =
          this.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Administration;
        this.resetPremiumAmount(originalFlightValue);
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft = originalFlightValue;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Net = premiumAmountVatTheftNet;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Tax = premiumAmountVatTheftTax;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Acquisition = premiumAmountVatTheftAcquisition;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Administration = premiumAmountVatTheftAdministration;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
        this.setUpdatedPricingData(this.updatedPricingData);
      }
    } else {
      if (this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked) {
        const originalFlightValue = this.getBackupFlight().Premium_Amount_VAT_Theft;
        const premiumAmountVatTheftNet = this.getBackupFlight().Premium_Amount_VAT_Theft_Net;
        const premiumAmountVatTheftTax = this.getBackupFlight().Premium_Amount_VAT_Theft_Tax;
        const premiumAmountVatTheftAcquisition = this.getBackupFlight().Premium_Amount_VAT_Theft_Acquisition;
        const premiumAmountVatTheftAdministration =
          this.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Administration;
        this.resetPremiumAmount(originalFlightValue);
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft = originalFlightValue;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Net = premiumAmountVatTheftNet;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Tax = premiumAmountVatTheftTax;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Acquisition = premiumAmountVatTheftAcquisition;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Administration = premiumAmountVatTheftAdministration;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
        this.setInitialPricingData(this.initialPricingData);
      }
    }
    this.setContentCovering(false);
    this.p5xService.setTheftChecked(false);
    this.capitalContentValue = this.capitlContentValueConstant;
    this.p5xService.setContentCapital(false);
    this.capitalContentValueStr = this.decimalPipe.transform(this.capitalContentValue, '0.2-2').replace(',', '');
    this.capitalContentValueStr = this.capitalContentValueStr.replace('.', ',');
    this.updateTarificationCall('0');
    this.tarifCheckboxStatus.Premium_VAT_Fire_Content_Checked = false;
    this.setTarifCheckboxStatus(this.tarifCheckboxStatus);
  }
  this.setCalculatedPremiumAfterUpdatingCapital(true);
}
resetPremiumAmount(originalFlightValue) {
  const originalFlightValueNum = +originalFlightValue.replace(',', '.');
  let premiumTotalAmountStr;
  let currentFlightValue;
  if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
    currentFlightValue = +this.getUpdatedPricingData().Tarification.Premium_Amount_VAT_Theft.replace(',', '.');
    premiumTotalAmountStr = this.getUpdatedPricingData().Tarification.Premium_Total_Amount.toString();
  } else {
    currentFlightValue = +this.getInitialPricingData().Tarification.Premium_Amount_VAT_Theft.replace(',', '.');
    premiumTotalAmountStr = this.getInitialPricingData().Tarification.Premium_Total_Amount.toString();
  }
  const premiumTotalAmount = +(premiumTotalAmountStr.replace(',', '.')) -
    (+(this.decimalPipe.transform(currentFlightValue, '0.2-2').replace(',', ''))) + originalFlightValueNum;
  premiumTotalAmountStr = this.decimalPipe.transform(premiumTotalAmount, '0.2-2').replace(',', '').replace('.', ',');
  this.setPremiumTotalAmount(premiumTotalAmountStr);
  if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
    this.updatedPricingData.Tarification.Premium_Total_Amount = premiumTotalAmountStr;
    this.setUpdatedPricingData(this.updatedPricingData);
  } else {
    this.initialPricingData.Tarification.Premium_Total_Amount = premiumTotalAmountStr;
    this.setInitialPricingData(this.initialPricingData);
  }
}
updateTarificationCall(capitalContenu) {
  this.global.showLoaderText = false;
  this.global.showprojectText = false;
  const request = this.updateTarifRequest('false', capitalContenu);
  this.getUpdatedTarificationEvaluationApi(request).subscribe((response) => {
    if (capitalContenu === '0') {
      this.capitalContentValueStr = this.capitalContentValueConstantStr;
    } else {
      this.capitalContentValueStr = this.decimalPipe.transform(capitalContenu, '0.2-2').replace(',', '').replace('.', ',');
    }
    this.updatedPricingData = this.updateTarifEnsuringContentCalculation(this.capitalContentValueStr, response);
    this.ensuringContentStr = this.updatedPricingData.Tarification.Premium_VAT_Fire_Content;
    this.setBtnCalculateClickedChk(true);
    this.global.calculateError = false;
    this.global.showLoaderText = false;
  });
  if (capitalContenu === '0') {
    this.capitalContentValue = this.convertToNumber(this.capitalContentValueStr);
    this.initialPricingData.Tarification.Premium_VAT_Fire_Content_Checked = false;
    this.ensureYourContentChecked = false;
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      this.updatedPricingData.Tarification.Premium_Total_Amount = this.premiumAmountStr;
      this.setUpdatedPricingData(this.updatedPricingData);
    }
  }
}
  //#endregion
}
